import { useState } from 'react';
import './App.css';
import MainPage from './Mainpage'; 
import { Routes, Route, useNavigate } from 'react-router-dom';
import MyButton from "./components/button/MyButton";

function App() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleSubmit = () => {
    console.log('Логин: ', login, 'Пароль: ', password)

    if (login === 'admin' && password === 'admin') {
      navigate("/Main")
    } 
    else {
      alert('Ошибка!');
    }
  }
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <div>
            <header className="App-header">
              <form onSubmit={(e) => {e.preventDefault(); handleSubmit();}}>
                <div className='inputLabel'>
                  <div className='innerInpusts'>
                    <p>Логин:</p>
                    <input
                      placeholder='Логин'

                      value={login}
                      onChange={(e) => setLogin(e.target.value)}
                    />
                    <p>Пароль:</p>
                    <input
                      type='password'
                      placeholder='Пароль'

                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div>
                    <MyButton className='submitButton'>
                      <p>Подтвердить</p>
                    </MyButton>
                  </div>
                </div>
              </form>
            </header>
            <p>Обратная связь: zevRPHFkZ1HkznjI</p>
          </div>
        }/>

        <Route path="/main" element={<MainPage/>} />

      </Routes>
    </div>
  );
}

export default App;
